(($) => {
    /************************ Variables *****************************/
    const mainArticleColumn = $('.article-main-col');
    const article = mainArticleColumn.find('article');
    const articleSections = article.find('.section-title[data-article-section]');
    const pageNavigation = $('.pageNavigation__list');
    const progressBar = $('.pageNavigation__progress--bar');

    /************************ Functions *****************************/

    /**
     * Sets the width of the progress bar based on the scroll percentage position.
     *
     * @param {number} scrollPercentagePosition - The scroll percentage position.
     */
    const setProgressBarWidth = (scrollPercentagePosition) => {
        if (scrollPercentagePosition < 5 ) {
            progressBar.css('width', '5%');
        } else {
            progressBar.css('width', `${scrollPercentagePosition}%`);
        }
    }

    const checkSectionsInView = () => {
        // Select all sections with the specified class
        const sections = Array.from(document.querySelectorAll('.section-title[data-article-section]'));
    
        // Get the current window's scroll position and dimensions
        const windowTop = window.scrollY;
        const windowBottom = windowTop + window.innerHeight;
    
        let inViewSections = [];
        let mostInViewSection = null;
        let mostInViewArea = 0;
    
        // Loop through each section
        sections.forEach(section => {
            // Get the top and bottom position of the section
            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.offsetHeight;
    
            // Check if the section is fully visible
            if (windowTop < sectionBottom && windowBottom > sectionTop) {
                const visibleArea = Math.min(windowBottom, sectionBottom) - Math.max(windowTop, sectionTop);
    
                inViewSections.push(section);
    
                // Check if this section has more area in view than the current most in view
                if (visibleArea > mostInViewArea) {
                    mostInViewArea = visibleArea;
                    mostInViewSection = section;
                }
            }
        });
    
        return {
            inViewSections,
            mostInViewSection
        };
    }

    /************************ Main *****************************/
    let navItems = [];
    articleSections.each((index, section) => {
        const href = $(section).data('article-section');
        const sectionTitle = section.textContent;
        navItems.push({
            href: `#${href}`,
            title: sectionTitle
        });
    });

    // make the pageNavigation Dragable on desktop devices
    const pageNavigationItems = $('.pageNavigation__item');
    if (pageNavigationItems.length > 0) {
        pageNavigationItems.forEach(item => {
            item.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('text/plain', e.target.id);
            })
        });
    };

    if (progressBar.length > 0) {
        // set the scroll bars initial width based off the page length and position
        const pageHeight = $(document).height();
        const windowHeight = $(window).height();
        const scrollableHeight = pageHeight - windowHeight;
        const scrollPercentage = (scrollableHeight / 100);
        let scrollPosition = $(window).scrollTop();
        let scrollPercentagePosition = scrollPosition / scrollPercentage;
        setProgressBarWidth(scrollPercentagePosition);
    
        $(window).scroll(() => {
            scrollPosition = $(window).scrollTop();
            scrollPercentagePosition = scrollPosition / scrollPercentage;
            setProgressBarWidth(scrollPercentagePosition);
            // call the checkSectionsInView function and get the most in view section
            const closestSection = checkSectionsInView().mostInViewSection;
            // get the href of the most in view section
            if (closestSection) {
                const href = `#${closestSection.dataset.articleSection}`;
                // remove the active class from all nav items
                $('.pageNavigation__item').removeClass('active');
                // add the active class to the nav item that matches the href
                $(`.pageNavigation__item a[href="${href}"]`).parent().addClass('active');

                const activeNavItem = $('.pageNavigation__item.active');
                const navList = $('.pageNavigation__list');
                const navListWidth = navList.width();
                const activeNavItemWidth = activeNavItem.width();
                const activeNavItemPosition = activeNavItem.position().left;
                const activeNavItemScrollLeft = navList.scrollLeft();

                // Check if the active item is the first one in the list
                if (activeNavItem.is(':first-child')) {
                    navList.scrollLeft(0);
                } else if (activeNavItemPosition < 0) {
                    navList.scrollLeft(activeNavItemScrollLeft + activeNavItemPosition - 10); // Add a 10px offset
                } else if (activeNavItemPosition + activeNavItemWidth > navListWidth) {
                    navList.scrollLeft(activeNavItemScrollLeft + activeNavItemPosition - navListWidth + activeNavItemWidth);
                } else if (activeNavItemPosition < navList.scrollLeft()) {
                    navList.scrollLeft(activeNavItemScrollLeft - activeNavItemPosition + 10); // Subtract a 10px offset
                }

            }
        });
    }

    if (navItems.length > 0) {
        const closestSection = checkSectionsInView().mostInViewSection;
        navItems.forEach((item, index) => {
            let isActive = closestSection && '#'+closestSection.dataset.articleSection === item.href ? 'active' : '';
            pageNavigation.append(`
            <li class="pageNavigation__item ${isActive}" tab-index="0">
                <a href="${item.href}" class="pageNavigation__link">${item.title}</a>
            </li>
            `);
        });
    
        // Smooth scroll to anchor
        $('.pageNavigation__item a').on('click', (e) => {
            e.preventDefault();
            const clicked = $(e.currentTarget);
            const target = clicked.attr('href').replace('#', '');
            $('.pageNavigation__item').removeClass('active');
            clicked.parent().addClass('active');
            $('html, body').animate({
                scrollTop: $(`.section-title[data-article-section=${target}]`).offset().top - 150
            }, 1000);
        });

        // Smooth scroll to anchor
        $('.pageNavigation__item a').on('keydown', (e) => {
            if (e.which === 13) { // 13 is the key code for Enter
                e.preventDefault();
                const clicked = $(e.currentTarget);
                const target = clicked.attr('href').replace('#', '');
                $('.pageNavigation__item').removeClass('active');
                clicked.parent().addClass('active');
                $('html, body').animate({
                    scrollTop: $(`.section-title[data-article-section=${target}]`).offset().top - 150
                }, 1000);
            }
        });
    } else {
        pageNavigation.remove();
    }

})(jQuery);